
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true,\"alias\":{\"fonts\":\"..fonts\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-26100638\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CabecalhoDoConteudo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CabecalhoDoConteudo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-26100638\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CabecalhoDoConteudo.vue"),
  /* scopeId */
  "data-v-26100638",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/shared/CabecalhoDoConteudo.vue
// module id = 1072
// module chunks = 1